<template>
  <div>
    <NewAberrationRuhContainer
      icon="mdi-progress-wrench"
      aberrationCategory="1"
      categoryName="Avvik"
      titleLabel="Overskrift"
      @save="save"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import notification from "@/helpers/notification";
import aberrationApi from "@/api/aberrationApi";

import NewAberrationRuhContainer from "@/components/aberration/new/children/NewAberrationRuhContainer.vue";

export default Vue.extend({
  methods: {
    save(aberration) {
      aberrationApi.aberrationInsertupdate(aberration).then(() => {
        notification.success("Avvik er lagt til!");
        this.$router.go(-1);
      });
    },
  },
  components: {
    NewAberrationRuhContainer,
  },
});
</script>
